module.exports = __webpack_public_path__ + "static/media/hammer.b7c40c7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/hammer.mp3
// module id = C81y
// module chunks = 1 3